import deviceKitName from "../../devices/deviceKitName";
import mercuryDevices from "./mercuryDevices";

const availableDeviceTypes = {
  [deviceKitName.IQOS_3_MULTI]: ["MONO"],
  [deviceKitName.IQOS_VEEV]: ["MONO"],
  [deviceKitName.IQOS_ILUMA_ONE]: ["DEVICE-CONTROL", "DEVICE-ENGINE"],
  [deviceKitName.IQOS_ORIGINALS_ONE]: ["MONO"],
  [deviceKitName.IQOS_ARIANE]: ["MONO"],
  [deviceKitName.IQOS_24]: ["CHARGER", "HOLDER"],
  [deviceKitName.IQOS_24P]: ["CHARGER", "HOLDER"],
  [deviceKitName.IQOS_3]: ["CHARGER", "HOLDER"],
  [deviceKitName.IQOS_3_DUO]: ["CHARGER", "HOLDER"],
  [deviceKitName.IQOS_ILUMA_PRIME]: ["CHARGER", "HOLDER-CONTROL", "HOLDER-ENGINE"],
  [deviceKitName.IQOS_ILUMA]: ["CHARGER", "HOLDER-CONTROL", "HOLDER-ENGINE"],
  [deviceKitName.IQOS_ILUMA_I]: ["CHARGER", "HOLDER-CONTROL", "HOLDER-ENGINE"],
  [mercuryDevices.MERCURY_L_LB_C]: ["CHARGER"],
  [mercuryDevices.MERCURY_L_LCD_C]: ["CHARGER"],
  [mercuryDevices.MERCURY_W_LB_C]: ["CHARGER"],
  [mercuryDevices.MERCURY_W_LCD_C]: ["CHARGER"]
};

export default availableDeviceTypes;
